import CategoryPage from ".";

const MaterialCategoryPage = () => (
  <CategoryPage
    type="material"
    title="Data Kategori Material"
    subtitle="master kategori material"
    description="Master kategori untuk pengelompokan bahan baku dan transaksi pembelian"
  />
);

export default MaterialCategoryPage;
